module.exports = __webpack_public_path__ + "static/media/add_stories_active.e396db16.svg";